import {
  Autocomplete,
  Box,
  FormControl,
  Grid,
  Skeleton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import React, { useEffect, useState } from "react";
import ApiService from "../../../services/ApiService";
import boxStyles from "../../../styles/boxStyles";
import { documentPosition } from "../../../constants/documentPosition";

const HeaderUser = ({
  inputFields,
  setInputFields,
  dataRegion,
  dataUnit,
  dataLokasi,
  readOnly = false,
  editVerified = false,
}) => {
  const handleUnit = (e, value) => {
    if (!value) {
      setInputFields((prev) => ({ ...prev, idUnitBisnis: null }));
    } else {
      setInputFields((prev) => ({ ...prev, idUnitBisnis: value.id }));
    }
  };

  // onChange={(e, value) => {
  //   if (!value) {
  //     handleRegion((prev) => ({
  //       ...prev,
  //       idUnitBisnis: null,
  //     }));
  //   } else {
  //     handleRegion((prev) => ({
  //       ...prev,
  //       idUnitBisnis: value.id,
  //     }));
  //   }
  // }}

  const handleRegion = (e, value) => {
    if (!value) {
      setInputFields((prev) => ({
        ...prev,
        idRegional: null,
        listApproval: [],
      }));
    } else {
      setInputFields((prev) => ({
        ...prev,
        idRegional: value.id,
        listApproval: [],
      }));
    }
  };
  const handleLokasi = (e, value, reason) => {
    console.log("handle lokasi", value, reason);
    if (reason === "clear" || value == null) return;

    if (reason === "select") {
      setInputFields((prev) => ({
        ...prev,
        idLokasi: value.id,
        listApproval: [],
      }));
    } else if (reason === "input") {
      // handle custom lokasi
      setInputFields((prev) => ({
        ...prev,
        idLokasi: null,
        namaLokasi: value,
        listApproval: [],
      }));
    }
  };

  return (
    <div>
      <Box component="div" sx={boxStyles}>
        <Grid container spacing={3}>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <Stack spacing={2}>
              <TextField
                name="noLkp"
                label="Nomor LKP"
                variant="standard"
                fullWidth
                disabled
                value={inputFields.noLkp ? inputFields.noLkp : ""}
                onChange={(e) => setInputFields((prev) => ({ ...prev, e }))}
              />
              {dataUnit.length === 0 ? (
                <Skeleton
                  variant="rectangular"
                  width={"auto"}
                  height={56}
                  animation="wave"
                />
              ) : (
                <FormControl fullWidth>
                  <Autocomplete
                    loading={dataUnit.length === 0}
                    name="idUnitBisnis"
                    onChange={(e, value) => handleUnit(e, value)}
                    required
                    defaultValue={dataUnit.find(
                      (item) => item.id === inputFields.idUnitBisnis
                    )}
                    getOptionLabel={(option) => option.name}
                    options={dataUnit}
                    renderInput={(params) => (
                      <TextField {...params} label="Unit Bisnis" />
                    )}
                    getOptionSelected={(option, value) =>
                      option.name === value.name
                    }
                    disabled={readOnly}
                  />
                </FormControl>
              )}

              {dataRegion.length === 0 ? (
                <Skeleton
                  variant="rectangular"
                  width={"auto"}
                  height={56}
                  animation="wave"
                />
              ) : (
                <FormControl fullWidth>
                  <Autocomplete
                    name="idRegional"
                    onChange={(e, value) => handleRegion(e, value)}
                    // onChange={(e, value) => {
                    //   if (!value) {
                    //     handleRegion((prev) => ({
                    //       ...prev,
                    //       idUnitBisnis: null,
                    //     }));
                    //   } else {
                    //     handleRegion((prev) => ({
                    //       ...prev,
                    //       idUnitBisnis: value.id,
                    //     }));
                    //   }
                    // }}
                    required
                    defaultValue={dataRegion.find(
                      (item) => item.id === inputFields.idRegional
                    )}
                    getOptionLabel={(option) => option.name}
                    options={dataRegion}
                    renderInput={(params) => (
                      <TextField {...params} label="Regional/Anak Perusahaan" />
                    )}
                    getOptionSelected={(option, value) =>
                      option.name === value.name
                    }
                    disabled={readOnly}
                  />
                </FormControl>
              )}

              {inputFields.idRegional !== null && dataLokasi.length === 0 ? (
                <>
                  <Skeleton
                    variant="rectangular"
                    width={"auto"}
                    height={56}
                    animation="wave"
                  />
                </>
              ) : (
                <>
                  <FormControl fullWidth>
                    <Autocomplete
                      name="idLokasi"
                      onChange={(e, value) => handleLokasi(e, value, "select")}
                      required
                      defaultValue={dataLokasi.find(
                        (item) => item.id === inputFields.idLokasi
                      )}
                      getOptionLabel={(option) => option.name}
                      options={dataLokasi}
                      renderInput={(params) => (
                        <TextField {...params} label="Lokasi" />
                      )}
                      getOptionSelected={(option, value) =>
                        option.name === value.name
                      }
                      freeSolo
                      onInputChange={(e, value, reason) =>
                        handleLokasi(e, value, reason)
                      }
                      disabled={readOnly}
                    />
                  </FormControl>
                </>
              )}
              <FormControl fullWidth>
                <Autocomplete
                  name="idRegional"
                  onChange={(e, value) =>
                    setInputFields((prev) => ({
                      ...prev,
                      documentPosition: value,
                      listApproval: [],
                    }))
                  }
                  value={inputFields.documentPosition}
                  required
                  getOptionLabel={(option) => option}
                  options={documentPosition}
                  renderInput={(params) => (
                    <TextField {...params} label="Posisi Pembuatan Dokumen" />
                  )}
                  disabled={readOnly === false ? editVerified : readOnly}
                />
              </FormControl>
            </Stack>
          </Grid>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <Stack spacing={2}>
              <TextField
                name="judulLaporan"
                label="Judul Laporan"
                variant="standard"
                fullWidth
                value={inputFields.judulLaporan ? inputFields.judulLaporan : ""}
                InputLabelProps={{ shrink: inputFields.judulLaporan !== "" }}
                onChange={(e) =>
                  setInputFields((prev) => ({
                    ...prev,
                    judulLaporan: e.target.value,
                  }))
                }
                disabled={readOnly}
              />
              <DesktopDatePicker
                name="tglKejadian"
                label="Tanggal Kejadian"
                variant="standard"
                fullWidth
                inputFormat="DD-MMMM-YYYY"
                value={inputFields.tglKejadian}
                onChange={(e) => {
                  setInputFields((prev) => ({
                    ...prev,
                    tglKejadian: e,
                  }));
                }}
                maxDate={new Date()}
                renderInput={(params) => <TextField {...params} />}
                disabled={readOnly}
              />
              <TimePicker
                label="Waktu Kejadian (Local Time)"
                name="waktuKejadian"
                fullWidth
                variant="standard"
                ampm={false}
                value={inputFields.waktuKejadian}
                onChange={(e) => {
                  setInputFields((prev) => ({
                    ...prev,
                    waktuKejadian: e,
                  }));
                }}
                inputFormat={"HH:mm"}
                views={["hours", "minutes"]}
                renderInput={(params) => <TextField {...params} />}
                disabled={readOnly}
              />
              <DesktopDatePicker
                name="tglLaporan"
                label="Tanggal Laporan"
                variant="standard"
                fullWidth
                inputFormat="DD-MMMM-YYYY"
                value={inputFields.tglLaporan}
                disabled
                onChange={(e) => {
                  setInputFields((prev) => ({
                    ...prev,
                    tglLaporan: e,
                  }));
                }}
                maxDate={new Date()}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <br />
      <Grid textAlign={"center"}>
        <Typography variant="body1">
          <b>LKP disubmit oleh : {inputFields.dokumenSubmitor}</b>
        </Typography>
        {inputFields.picLapInvestigasi !== null ? (
          <>
            <Typography variant="body1">
              <b>PIC Laporan Investigasi : {inputFields.picLapInvestigasi}</b>
            </Typography>
          </>
        ) : null}
      </Grid>
    </div>
  );
};

export default HeaderUser;
